export default function useFormSync({ methods, setFormData, handleCalAmount }) {
  if (!methods) {
    return { onSync: () => {} };
  }

  const { setValue } = methods;

  const onSync = (fieldName, formatted) => {
    try {
      setValue(fieldName, formatted, {
        shouldValidate: false,
        shouldDirty: true,
        shouldTouch: false,
      });
    } catch (e) {
      // ignore individual set failures silently
    }
  };

  return { onSync };
}
